export const environment = {
  production: true,
  apiUrl: 'https://u2m.api.tlspreprod.alzp.tgscloud.net',
  apiPublicUrl: 'https://public.tlspreprod.alzp.tgscloud.net',
  oauth: {
    clientId: '4317f750-a5a3-4e30-b721-5f53ad062864',
    issuer: 'https://login.microsoftonline.com/329e91b0-e21f-48fb-a071-456717ecc28e/v2.0',
    redirectUri: 'https://smeermiddelen-shopmanagertest123.totalenergies.nl',
    postLogoutRedirectUri: 'https://smeermiddelen-shopmanagertest123.totalenergies.nl',
    waitForTokenMsec: 2000,
    scope: 'openid profile email api://7a6ba174-33c9-4454-863b-86fe625c66cf/Default',
    requireHttps: false,
    showDebugInformation: true,
    strictDiscoveryDocumentValidation: false,
    // Setting below will automatically add token to headers
    // (make sure to set the proper URL for the API backend)
    resourceServer: {
      allowedUrls: [
        'https://u2m.api.tlspreprod.alzp.tgscloud.net',
        'https://public.tlspreprod.alzp.tgscloud.net',
      ],
      sendAccessToken: true,
    },
  },
  authorization: {
    requiredRoles: ['shop_admin'],
  },
  errorHandling: {
    httpIgnoreKeys: ['trace', 'details', 'exception_stack'],
  },
  translation: {
    defaultLanguage: 'en',
    fallbackLanguage: 'en',
  },
  tls: {
    roleOptions: ['shop_user', 'shop_admin', 'shop_reseller', 'shop_guest'],
    organization: {
      countryOptions: [
        { id: 'NL', name: 'Netherlands' },
        { id: 'BE', name: 'Belgium' },
        { id: 'CZ', name: 'Czech' },
        { id: 'FR', name: 'France' },
        { id: 'GB', name: 'United Kingdom' },
        { id: 'DE', name: 'Germany' },
        { id: 'LV', name: 'Latvia' },
      ],
    },
    telemetry: {
      oilTypes: [
        { id: 0, name: 'Fresh oil' },
        { id: 1, name: 'Waste oil' },
        { id: 2, name: 'Diesel' },
      ],
      tankTypes: [
        { id: 0, name: 'Bulk' },
        { id: 1, name: 'Drum' },
      ],
    },
  },
};
